<script setup>
import { useSlots } from 'vue';
const {
  isDropdownVisible,
  source,
  dropdownList,
  selectedItemId,
  selectedClass,
  unselectedClass,
  textSize,
  showCount,
  getCount,
} = defineProps({
  isDropdownVisible: {
    type: Boolean,
    required: true,
  },
  dropdownList: {
    type: Array,
    required: true,
  },
  selectedItemId: {
    type: [String, Number],
    required: false,
    default: null,
  },
  textSize: {
    type: String,
    required: false,
    default: 'text-base',
  },
  selectedClass: {
    type: String,
    required: false,
    default: 'border-sun-500 text-steel-900',
  },
  unselectedClass: {
    type: String,
    required: false,
    default: 'border-transparent text-steel-700',
  },
  showCount: {
    type: Boolean,
    required: false,
    default: false,
  },
  getCount: {
    type: Function,
    required: false,
    default: () => 0,
  },
  source: {
    type: String,
    required: false,
    default: '',
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const slots = useSlots();
const emit = defineEmits(['dropdownClick']);
const handleDropdownClick = (item) => {
  emit('dropdownClick', item, source);
};
</script>

<template>
  <div class="absolute inset-0 top-full">
    <div>
      <div class="relative">
        <ul
          v-if="isDropdownVisible"
          class="absolute z-10 mt-1 max-h-60 w-full min-w-fit overflow-auto rounded-md bg-white py-1 shadow-[0px_8px_12px_0px_rgba(31,36,46,0.16)] ring-1 ring-black ring-opacity-5 focus:outline-none"
          tabindex="-1"
          role="listbox"
          aria-labelledby="listbox-label"
        >
          <!-- aria-activedescendant="listbox-option-3" -->
          <!-- :class="{
              'border-l-2 border-yellow-500': selectedItemId === item.id,
            }" -->
          <div v-if="isLoading">
            <img
              class="loading m-auto my-3 h-8 w-8"
              src="@/assets/loading-v2-yellow.svg"
              alt="loading spinner"
            />
          </div>
          <div v-else>
            <li
              v-for="item in dropdownList"
              :key="item.id"
              class="active:bg-alert-closed-border group relative cursor-pointer select-none border-l-[3px] py-1 text-xs hover:bg-steel-100"
              :class="[
                textSize,
                selectedItemId == item.id ? selectedClass : unselectedClass,
              ]"
              role="option"
              @click.stop="handleDropdownClick(item)"
            >
              <div class="h-6 min-w-fit px-2">
                <div
                  v-if="slots.leftDropdownIcon"
                  class="h-6 w-6"
                >
                  <slot name="leftDropdownIcon"></slot>
                </div>
                <span
                  class="flex h-6 items-center whitespace-nowrap font-medium"
                >
                  {{
                    item?.label + (showCount ? ` (${getCount(item?.id)})` : '')
                  }}
                </span>
                <div
                  v-if="slots.rightDropdownIcon"
                  class="h-6 w-6"
                >
                  <slot name="rightDropdownIcon"></slot>
                </div>
              </div>
            </li>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
